import type { BffApiClient } from "@/app/api-client"
import type { NftId } from "@anaconda/core/nft/types"

export function getRoyaltyQueryParams(apiClient: BffApiClient, nftId: NftId) {
  return {
    queryKey: ["nft", nftId, "royalty"],
    queryFn: async () => {
      if (nftId === undefined) {
        throw new Error("NFT ID is required for royalty query")
      }
      const response = await apiClient.api.nfts[":id"].royalty.$get({
        param: { id: nftId },
      })

      if (!response.ok) throw await response.json()

      const result = response.json()

      return result
    },
  }
}
